import React from "react";
import { HStack, VStack } from "@chakra-ui/react";

import {
  AddMultipleImageModal,
  AddCSVModal,
  AddScratchpadModal,
  AddBaseplatesModal,
  AddCarrierPlatesModal,
  AddCernUploadInfoModal,
} from "@components";

import { Layout } from "./PageLayouts";

export function ImportCernDBPage() {
  return (
    <Layout variant="centered">
      <VStack gap="32px">
        <HStack w="100%" justifyContent="space-around">
          <AddMultipleImageModal itemId={""} />
          <AddCSVModal itemId={""} />
          <AddScratchpadModal itemId={""} />
          <AddBaseplatesModal itemId={""} />
          <AddCarrierPlatesModal itemId={""} />
          <AddCernUploadInfoModal itemId={""} />
        </HStack>
      </VStack>
    </Layout>
  );
}
